<template>
  <DataTable :value="rows" data-key="id" striped-rows>
    <Column
      v-for="column in columns"
      :key="column.field"
      :field="column.field"
      :header="column.header"
    >
      <template v-if="column.type === 'status'" #body="{ data }">
        <Tag
          :value="statusLabel(data[column.field])"
          :severity="statusSeverity(data[column.field])"
        />
      </template>
      <template v-else-if="column.type === 'date'" #body="{ data }">
        {{ formatDate(data[column.field]) }}
      </template>
      <template v-else-if="column.type === 'category'" #body="{ data }">
        {{ categoryLabel(data[column.field]) }}
      </template>
      <template v-else-if="column.type === 'type'" #body="{ data }">
        <Tag
          :value="typeLabel(data[column.field])"
          :severity="data[column.field] === 'bereichsuebergreifend' ? 'warn' : 'info'"
        />
      </template>
    </Column>
  </DataTable>
</template>

<script>
import { DataTable, Column, Tag } from 'primevue';

export default {
  name: 'ArchiveEntityTable',
  components: {
    DataTable,
    Column,
    Tag,
  },
  props: {
    entity: {
      type: String,
      required: true,
    },
    rows: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    columns() {
      if (this.entity === 'commitments') {
        return [
          { field: 'was', header: this.$t('ProjectManagement.commitments.columns.was') },
          { field: 'dueDate', header: this.$t('ProjectManagement.commitments.columns.dueDate'), type: 'date' },
          { field: 'status', header: this.$t('ProjectManagement.commitments.columns.status'), type: 'status' },
        ];
      }
      if (this.entity === 'constraints') {
        return [
          { field: 'description', header: this.$t('ProjectManagement.constraints.columns.description') },
          { field: 'type', header: this.$t('ProjectManagement.constraints.columns.type'), type: 'type' },
          { field: 'dueDate', header: this.$t('ProjectManagement.constraints.columns.dueDate'), type: 'date' },
          { field: 'status', header: this.$t('ProjectManagement.constraints.columns.status'), type: 'status' },
        ];
      }
      if (this.entity === 'decisions') {
        return [
          { field: 'title', header: this.$t('ProjectManagement.decisions.columns.title') },
          { field: 'dueDate', header: this.$t('ProjectManagement.decisions.columns.dueDate'), type: 'date' },
          { field: 'status', header: this.$t('ProjectManagement.decisions.columns.status'), type: 'status' },
        ];
      }
      return [
        { field: 'title', header: this.$t('ProjectManagement.milestones.columns.title') },
        { field: 'dueDate', header: this.$t('ProjectManagement.milestones.columns.dueDate'), type: 'date' },
        { field: 'actualDate', header: this.$t('ProjectManagement.milestones.columns.actualDate'), type: 'date' },
        { field: 'status', header: this.$t('ProjectManagement.milestones.columns.status'), type: 'status' },
      ];
    },
  },
  methods: {
    formatDate(value) {
      if (!value) return '—';
      return new Date(value).toLocaleDateString();
    },
    statusLabel(status) {
      if (this.entity === 'commitments') {
        return this.$t(`ProjectManagement.commitments.status.${status}`);
      }
      if (this.entity === 'constraints') {
        return this.$t(`ProjectManagement.constraints.status.${status}`);
      }
      if (this.entity === 'decisions') {
        return this.$t(`ProjectManagement.decisions.status.${status}`);
      }
      return this.$t(`ProjectManagement.milestones.status.${status}`);
    },
    statusSeverity(status) {
      if (status === 'done' || status === 'resolved' || status === 'decided') return 'success';
      if (status === 'not_done' || status === 'escalated' || status === 'at_risk') return 'danger';
      if (status === 'on_track' || status === 'prepared') return 'info';
      return 'warn';
    },
    typeLabel(type) {
      return this.$t(`ProjectManagement.constraints.type.${type}`);
    },
    categoryLabel(category) {
      return this.$t(`ProjectManagement.commitments.cause.categories.${category}`);
    },
  },
};
</script>
